// extracted by mini-css-extract-plugin
export default {"newspage":"newspage_newspage__MAmNV"};